import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetch, Headers } from './bff-fetch';

export class HotelInfoSource {
  private readonly host: string;
  private readonly logger: Logger;
  private readonly forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore, criteria: any, hotelId: number) {
    return bffFetch(this.host, `hotel/${hotelId}`, context, criteria, this.logger, this.forwardedHeaders);
  }

  public fetchSimilarHotels(context: ContextStore, params: any, hotelId: number) {
    return bffFetch(this.host, `hotel/${hotelId}/recommended-hotels`, context, params, this.logger, this.forwardedHeaders);
  }
}
